'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createPath = require('./utils/createPath');

var _createPath2 = _interopRequireDefault(_createPath);

var _ensureLocation = require('./utils/ensureLocation');

var _ensureLocation2 = _interopRequireDefault(_ensureLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function noop() {}

var ServerProtocol = function () {
  function ServerProtocol(url) {
    _classCallCheck(this, ServerProtocol);

    this._location = (0, _ensureLocation2.default)(url);
  }

  ServerProtocol.prototype.init = function init() {
    return _extends({
      action: 'POP'
    }, this._location);
  };

  ServerProtocol.prototype.subscribe = function subscribe() {
    // Server protocol emits no events.
    return noop;
  };

  ServerProtocol.prototype.createHref = function createHref(location) {
    return (0, _createPath2.default)(location);
  };

  // The other methods are not implemented, because ServerProtocol instances
  // cannot navigate.


  return ServerProtocol;
}();

exports.default = ServerProtocol;
module.exports = exports['default'];